import { render } from "./UpdateNotification.vue?vue&type=template&id=16e23a74&scoped=true"
import script from "./UpdateNotification.vue?vue&type=script&lang=js"
export * from "./UpdateNotification.vue?vue&type=script&lang=js"

import "./UpdateNotification.vue?vue&type=style&index=0&id=16e23a74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16e23a74"]])

export default __exports__